import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoGift = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Gift</title>
    <rect
      x={4.598}
      y={11.918}
      width={22.807}
      height={5.068}
      rx={1.143}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.132 16.985H24.87v9.118a2.286 2.286 0 0 1-2.286 2.286H9.418a2.286 2.286 0 0 1-2.286-2.286v-9.118ZM16.002 28.389V11.917M9.151 10.79c1.96 1.206 4.743 1.125 6.849 1.125-1.031-1.186-1.744-3.07-3.16-4.5C11.12 5.68 8.793 4.912 7.57 6.29c-1.13 1.689.109 3.595 1.581 4.5ZM21.874 11.035c-1.68.945-4.065.881-5.87.881.883-.929 1.494-2.407 2.709-3.527 1.474-1.36 3.556-2.193 4.516-.882.968 1.324-.093 2.818-1.355 3.528Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoGift;
